<template>
  <div>
    <div v-if="show">
      <v-col cols="10" offset="1" class="pa-0">
        <v-row class="justify-center ma-2">
          <h3 class="primary--text">Lista de Orçamentos</h3>
        </v-row>
        <v-row class="justify-center">
          <v-list>
            <v-list-item-group v-model="active" color="primary">
              <v-list-item
                three-line
                v-for="calc in calcs"
                :key="calc.id"
                aria-selected="active"
              >
                <v-list-item-content @click="view(calc)">
                  <v-list-item-title class="primary--text">{{
                    calc.data
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="primary--text mr-3"
                      >{{ calc.clienteEmail }}{{ " - " }}{{ calc.tipo }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <span class="accent--text mr-3"
                      >{{ calc.tamanho }}{{ " " }}</span
                    >
                    <span class="accent--text mr-3"
                      >{{ laminas(calc) }}{{ " lâminas" }}</span
                    >
                    <strong>{{ calc.valor }}</strong>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action class="py-5 px-3 ma-1">
                  <v-btn icon color="red" @click="deletar(calc)">
                    <v-icon color="red">mdi-delete-outline</v-icon>
                  </v-btn>
                </v-list-item-action>

              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-row>
      </v-col>
      <v-dialog
        v-model="dialog"
        scrollable
        persistent
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title primary-title>
            {{ item.clienteNome }}{{ item.clienteEmail }}
            <v-spacer></v-spacer>
            {{ item.valor }}
          </v-card-title>
          <v-card-subtitle>
            {{ item.data }}
            <strong class="ml-3">{{ item.clientePhone }}</strong>
          </v-card-subtitle>
          <v-card-text>
            <v-col cols="12">
              <v-row>
                <strong class="pr-2">{{ "Tipo:" }}</strong
                ><span>{{ item.tipo }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Tamanho:" }}</strong
                ><span>{{ item.tamanho }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Lâminas:" }}</strong
                ><span>{{ laminas(item) }}</span>
              </v-row>
              <v-row v-if="item.tipo !== 'Álbum Slim'">
                <strong class="pr-2">{{ "Capa:" }}</strong><span>{{ item.capa }}</span>
                <strong v-if="item.capa !== 'Capa foto'" class="ml-8 pr-2">{{ "Mostruário:" }}</strong><span>{{ item.mostruario }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Laminação:" }}</strong
                ><span>{{ item.laminacao }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Acessórios:" }}</strong>
              </v-row>
              <v-row class="pl-6" v-for="ac in item.acessorios" :key="ac">
                <span class="pl-6">{{ ac }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Demanda especial:" }}</strong
                ><span>{{ item.obs }}</span>
              </v-row>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-btn color="accent" text @click="gerarPDF(item)">GERAR PDF</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click="fechar()">fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog2"
        scrollable
        persistent
        :overlay="false"
        max-width="500px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title primary-title>{{ "DELETAR ORÇAMENTO?" }}</v-card-title>
          <v-card-subtitle>
            {{ remover.data }}
            <strong class="ml-3">{{ remover.clienteEmail }}</strong>
          </v-card-subtitle>
          <v-card-text>
            <v-col cols="12">
              <v-row>
                <strong class="pr-2">{{ "Tipo:" }}</strong
                ><span>{{ remover.tipo }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Tamanho:" }}</strong
                ><span>{{ remover.tamanho }}</span>
              </v-row>
              <v-row>
                <strong class="pr-2">{{ "Lâminas:" }}</strong
                ><span>{{ laminas(remover) }}</span>
              </v-row>
            </v-col>
          </v-card-text>
          <v-card-actions>
            <v-btn color="warning" text @click="fechar()">não </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="remove(remover.id)">sim </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div v-else>
      <v-row style="height: 80vh" class="justify-center align-center">
        <v-progress-circular
          :size="60"
          :width="8"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "my-list",
  computed: {
    user() {
      return this.$store.getters.user;
    },
    calcs() {
      const c = this.$store.getters.calcs;
      return c;
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.user) {
        this.show = true
      }
    }, 1000);
  },
  data() {
    return {
      show: false,
      loading: false,
      active: "",
      dialog: false,
      dialog2: false,
      remover: "",
      item: {},
    };
  },
  methods: {
    laminas(calc) {
      const num = Number(calc.laminas) + Number(calc.extras);
      return num;
    },
    view(calc) {
      this.item = calc;
      this.dialog = true;
    },
    gerarPDF(item) {
      this.$store.dispatch('setOrcamento', item)
      this.$router.push('/gerarpdf')
    },
    fechar() {
      this.item = {};
      this.dialog = false;
      this.remover = {};
      this.dialog2 = false;
    },
    deletar(calc) {
      this.remover = calc;
      this.dialog2 = true;
    },
    remove(id) {
      this.$store.dispatch("deleteCalc", id);
      this.$store.dispatch("loadCalcsUser", this.user.uid);
      this.fechar();
    },
  },
};
</script>
